import { FadeIn } from '../components/AnimateIn'
import Button from '../components/Button'
import Hero from '../components/Hero'
import Leader from '../components/Leader'
import Page from '../components/Page'
import Section from '../components/Section'
import { Text } from '../components/Text'

export default function About() {
  return (
    <Page>
      <Hero
        title='About Us'
        button={
          <div className='flex flex-row gap-6'>
            <Button variant='default' icon='ArrowRight' href='/contact'>
              Contact Us
            </Button>
          </div>
        }
        image='About'
      >
        <div className='flex flex-1'>
          <Text.BodyLarge>
            <p>
              We are a Bible-based congregation, known as “Brethren,” gathering in the name of the
              Lord Jesus Christ. As an independent assembly in Dubai, UAE, we testify to God’s love
              and grace, coming together for worship, fellowship, prayer, and Bible study.
            </p>
          </Text.BodyLarge>
        </div>
      </Hero>
      <div className='flex flex-col lg:flex-row'>
        <FadeIn delay={0.1}>
          <Section withVerticalPadding className='flex-2'>
            <div className='flex flex-col gap-24'>
              <p className='flex flex-col gap-10'>
                <Text.H2>Our Mission</Text.H2>
                <Text.Body>
                  Our mission is to be a Christ-centered community, worshiping Jesus by embracing
                  His love, proclaiming salvation through His name, and sharing His love with each
                  other, our community, and the world.
                </Text.Body>
              </p>
              <p className='flex flex-col gap-10'>
                <Text.H2>About Bible</Text.H2>
                <Text.Body>
                  We believe the Bible, consisting of 39 books in the Old Testament and 27 in the
                  New Testament, to be the divinely inspired and authoritative Word of God. We hold
                  that it is inerrant, infallible, and historically accurate. As such, we recognize
                  it as the ultimate authority in all matters of faith, doctrine, and practice.
                </Text.Body>
              </p>
              <p className='flex flex-col gap-10'>
                <Text.H2>About God</Text.H2>
                <Text.Body className='flex flex-col gap-6'>
                  <p>
                    We believe in the unity of the Godhead and the Trinity of its persons—Father,
                    Son, and Holy Spirit—each sovereign, co-equal, and co-eternal.
                  </p>
                  <p>
                    We believe in the Lord Jesus Christ, both fully God and fully man, as the
                    incarnate Son of God, conceived by the Holy Spirit and born of the virgin Mary.
                    We affirm His perfect life, His teachings, His atoning and substitutionary death
                    on the cross, through which He triumphed over Satan, sin, and death, His bodily
                    resurrection, and His ascension to Heaven, where He is seated in glory at the
                    right hand of God the Father.
                  </p>
                  <p>
                    We believe in the regenerating, sanctifying, indwelling, and sealing work of the
                    Holy Spirit, who baptizes each believer into the body of Christ upon accepting
                    Jesus as Savior and Lord. The Holy Spirit equips believers with spiritual gifts
                    and empowers them to experience fellowship with God in this world.
                  </p>
                </Text.Body>
              </p>
              <p className='flex flex-col gap-10'>
                <Text.H2>Man’s Redemption</Text.H2>
                <Text.Body className='flex flex-col gap-6'>
                  <p>
                    We believe in the total depravity of humanity and the absolute necessity of
                    spiritual rebirth for personal salvation, affirming that all who believe are
                    members of the Church, the body of Christ.
                  </p>
                  <p>
                    We believe that salvation is granted solely by the grace of God, not through any
                    human effort or merit. We hold that salvation, once given, is secure and cannot
                    be lost.
                  </p>
                  <p>
                    We believe in the priesthood of all believers, with the Lord Jesus Christ as our
                    High Priest and the only mediator between God and humankind.
                  </p>
                </Text.Body>
              </p>
              <p className='flex flex-col gap-10'>
                <Text.H2>Church’s Future</Text.H2>
                <Text.Body className='flex flex-col gap-6'>
                  <p>
                    We believe the Universal Church is the body of Christ, composed of all
                    born-again believers who acknowledge Jesus Christ’s Lordship in every area of
                    life.{' '}
                  </p>
                  <p>
                    We affirm that each local church is an independent, autonomous body under the
                    headship of Jesus Christ alone. We hold to the future rapture of the Church,
                    when Jesus Christ will return in the clouds to gather His people to Himself, and
                    to His second coming to earth with His saints to establish His reign.{' '}
                  </p>
                  <p>
                    We believe in the resurrection of both the just and the unjust, the eternal
                    blessedness of the saved, and the eternal conscious punishment of the unsaved.
                  </p>
                </Text.Body>
              </p>
              <p className='flex flex-col gap-10'>
                <Text.H2>The Believer</Text.H2>
                <Text.Body className='flex flex-col gap-6'>
                  <p>
                    We believe it is the duty and privilege of every believer to participate in
                    making new disciples, fulfilling the Great Commission through personal
                    evangelism and missions.
                  </p>
                  <p>
                    We hold that each believer should seek God’s will as the supreme purpose in
                    life, trusting that all things work for the good of those who love Him.
                  </p>
                  <p>
                    We recognize God as the source of all blessings and that everything we possess
                    belongs to Him. Therefore, we encourage cheerful, regular, and generous
                    contributions of time, gifts, and resources for the advancement of His kingdom.
                  </p>
                </Text.Body>
              </p>
              <p className='flex flex-col gap-10'>
                <Text.H2>The Ordinances</Text.H2>
                <Text.Body>
                  We believe in believer’s baptism by full immersion in water, conducted in the name
                  of the Father, Son, and Holy Spirit. We also uphold the remembrance of the Lord’s
                  Table, where baptized believers partake in the Bread and Wine, honoring Christ’s
                  sacrifice and living in obedience to His commandments.
                </Text.Body>
              </p>
              <p className='flex flex-col gap-10'>
                <Text.H2>The Lord’s Supper</Text.H2>
                <Text.Body>
                  The Bread and Wine are to be partaken only by those who are born again, have
                  received believer’s baptism by immersion, and are walking faithfully with the Lord
                  Jesus Christ.
                </Text.Body>
              </p>
            </div>
          </Section>
        </FadeIn>
        <Section
          withVerticalPadding
          className='flex flex-1 bg-neutral-100 lg:min-w-[469px] flex-nowrap lg:px-[64px]'
        >
          <div className='flex flex-col gap-[60px]'>
            <div className='flex flex-col gap-[44px]'>
              <FadeIn>
                <Text.H2 className='text-nowrap flex flex-row flex-nowrap'>
                  <p>
                    Our <Text.Gradient>Oversight</Text.Gradient>
                  </p>
                </Text.H2>
              </FadeIn>
              <FadeIn delay={0.1}>
                <Text.Body>
                  Our church is overseen by elders and deacons in accordance with the Word of God.
                </Text.Body>
              </FadeIn>
            </div>
            <div className='flex flex-col md:flex-row lg:flex-col md:flex-wrap lg:flex-nowrap gap-3 w-full'>
              <Leader index={0} title='Evangelist'>
                Paul Vargese
              </Leader>
              <Leader index={1} title='Elder'>
                M. V. Sunny
              </Leader>
              <Leader index={2} title='Elder'>
                Sunil Philip
              </Leader>
              <Leader index={3} title='Deacon'>
                Prasad Daniel
              </Leader>
              <Leader index={4} title='Deacon'>
                Thomas Samuel
              </Leader>
              <Leader index={5} title='Deacon'>
                Suresh Jacob
              </Leader>
              <Leader index={6} title='Deacon'>
                Thomas Chandy
              </Leader>
              <Leader index={7} title='Deacon'>
                Jobin Rajan
              </Leader>
              <Leader index={8} title='Deacon'>
                Sheji Jos
              </Leader>
            </div>
          </div>
        </Section>
      </div>
    </Page>
  )
}
